import { FC } from "react";
import { useTranslation } from "react-i18next";
import ProductCategoryDescription from "../product-category-description/product-category-description";
import { ProductInformationWrapper } from "../product-information/product-information.styled";

const ServiceInformation: FC = () => {
  const { t } = useTranslation();

  return (
    <ProductInformationWrapper>
      <div className="title">
        <div className="text">
          {t("productComponent.service.information.title")}
        </div>
      </div>
      <div className="content">
        <ProductCategoryDescription />
      </div>
    </ProductInformationWrapper>
  );
};

export default ServiceInformation;
